import { MenuItemModel } from "../menu-items/menu-item.model";
import { CurrencyModel } from "./currency.model";

export class MenuAndCategoryDetailsModel {
  public id :string;
  public name:string;
  public createDate:string;
  public venueMenuCategories: Array<MenuAndCategoryDetailsModel>;
  public childVenueMenuCategories: Array<MenuAndCategoryDetailsModel>;
  public venueMenuItems: Array<MenuItemModel>;
  public defaultCurrencyId: string;
  public defaultCurrency: CurrencyModel;
}
